import { switchMap } from 'rxjs';

import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';

import { environment } from '../../../../environments/environment';
import { ISearchResponse } from '../../../core/interfaces/search-response.interface';
import { SalesChannelService } from '../../../core/services/sales-channel-autorization.service';

interface SearchRequest {
  postalCode: string;
  plate: string;
  products: Array<{
    specifications: string[];
    productGroups: string[];
    description: string;
    amount?: number;
  }>;
}

@Injectable({ providedIn: 'root' })
export class SearchService {
  private readonly http = inject(HttpClient);
  private readonly api = environment.gateway.external;
  private readonly salesChannelAuthService = inject(SalesChannelService);

  search(postalCode: string, description: string, plate: string) {
    const request: SearchRequest = {
      postalCode,
      plate,
      products: [
        {
          description,
          productGroups: [],
          specifications: [],
          amount: 1,
        },
      ],
    };

    return this.salesChannelAuthService.credentials$.pipe(
      switchMap((token) =>
        this.http.post<ISearchResponse>(`${this.api}/sales-channels/v1/products/search`, request, {
          headers: new HttpHeaders({
            Authorization: `Bearer ${token}`,
          }),
        })
      )
    );
  }
}
